import AutomationError from './AutomationError';
class InvestorHasInvalidFiscalZipCode extends AutomationError {
    constructor(options) {
        super('The investor’s fiscal zip is not valid.', options);
    }
}
export default InvestorHasInvalidFiscalZipCode;
